import React from 'react';

import { EmptyState } from '@lumapps/lumx-states/components/EmptyState';
import { useTranslate } from '@lumapps/translations';

import { ERROR_STATES_BY_CODE } from '../../constants';
import { AskAiServiceErrors } from '../../types';

export interface AskAiErrorStateProps {
    /** The error details */
    error?: AskAiServiceErrors;
}

/**
 * Error state of the ask ai banner
 * Will display an specific error for maximum usage
 */
export const AskAiErrorState: React.FC<AskAiErrorStateProps> = ({ error }) => {
    const { translateKey } = useTranslate();

    /** Retrieve the correct error message depending on the code. */
    const errorMessage = (error?.code && ERROR_STATES_BY_CODE[error?.code]) || ERROR_STATES_BY_CODE.default;

    return (
        <EmptyState
            title={translateKey(errorMessage.subtitle)}
            message={translateKey(errorMessage.description)}
            iconProps={{ icon: errorMessage.icon }}
        />
    );
};
